export const MAX_BOARD_BUMPS = 3;
export const BOARD_BUMP_SETTLE_TIME = 1.5;
export const BOARD_BUMP_ANIMATION_TIME = 0.3;

// Change velocity, rather than the die's position or landing cell, so the
// regular collision and settling simulation still determines the outcome.
export const applyBoardBump = (
  physics,
  position,
  { allowed, target, edgeLimit, maxBumps = MAX_BOARD_BUMPS }
) => {
  if (
    !allowed ||
    physics.completed ||
    physics.grounded ||
    (!physics.active && !physics.grounding) ||
    physics.bumpsUsed >= maxBumps
  ) {
    return false;
  }

  let directionX = target
    ? Math.max(-edgeLimit, Math.min(edgeLimit, target.x)) - position.x
    : 0;
  let directionZ = target
    ? Math.max(-edgeLimit, Math.min(edgeLimit, target.z)) - position.z
    : -1;
  if (Math.hypot(directionX, directionZ) < 0.05) {
    directionX = 0;
    directionZ = -1;
  }
  // At an edge, push back onto the board instead of spending a bump against
  // the boundary wall.
  if (Math.abs(position.x) >= edgeLimit - 0.3 && directionX * position.x > 0) {
    directionX *= -1;
  }
  if (Math.abs(position.z) >= edgeLimit - 0.3 && directionZ * position.z > 0) {
    directionZ *= -1;
  }
  const length = Math.hypot(directionX, directionZ);
  directionX /= length;
  directionZ /= length;

  physics.velocity.x = physics.velocity.x * 0.4 + directionX * 5.6;
  physics.velocity.z = physics.velocity.z * 0.4 + directionZ * 5.6;
  const horizontalSpeed = Math.hypot(physics.velocity.x, physics.velocity.z);
  if (horizontalSpeed > 8) {
    physics.velocity.x *= 8 / horizontalSpeed;
    physics.velocity.z *= 8 / horizontalSpeed;
  }
  physics.velocity.y = Math.max(physics.velocity.y, 2.7);
  physics.angular.x += directionZ * 5;
  physics.angular.z -= directionX * 5;
  physics.active = true;
  physics.grounding = false;
  physics.grounded = false;
  physics.resting = false;
  physics.onGround = false;
  physics.restingTime = 0;
  physics.groundElapsed = 0;
  physics.bumpsUsed += 1;
  physics.bumpTime = BOARD_BUMP_ANIMATION_TIME;
  physics.rollDeadline = Math.max(
    physics.rollDeadline,
    physics.rollElapsed + BOARD_BUMP_SETTLE_TIME
  );
  return true;
};
